module.exports = __webpack_public_path__ + "img/mongodb-logo.6c81866b.png";